import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { QSLUTEntry, QSConvLUTEntry, AttributesService } from 'src/app/model/api-services/attributes.service';

export type CastingFormatType = '' | 'number-general' | 'number-sci' | 'number-dec' | 'number-hex' | 'number-octal' | 'number-binary' | 'number-fraction' | 'number-phone' | 'number-currency' | 'number-percentage' | 'number-geoloc-part' | 'number-zipcode' | 'date' | 'time' | 'text' | 'text' | 'link' | 'boolean' | 'media';

@Component({
	selector: 'app-casting-formats-sel',
	templateUrl: './casting-formats-sel.component.html',
	styleUrls: ['./casting-formats-sel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CastingFormatsSelComponent implements OnInit {

	public options: Array<QSLUTEntry> = [];
	public defaultIndex = 0;
	public _val = '';
	public attributeSet = false;
	private att: AttributeInfo;


	@Input()
	set attribute(att: AttributeInfo) {
		if (!att) {
			return;
		}
		this.attributeSet = false;
		this.cdr.detectChanges();
		this.att = att;
		//window.requestAnimationFrame(() => {

		let attType = this.attribute.type;
		if (this.attribute.type === 'string') {
			if (this.attribute.requires === 'url') {
				attType = 'url';
			}
		}
		const info: QSConvLUTEntry = AttributesService.GetConversionLUT(attType);
		if (!!info) {
			this.options = info.options;
			this.defaultIndex = info.defaultIndex;
		}
		this.attributeSet = true;
		this.cdr.detectChanges();
		// })
	}
	get attribute(): AttributeInfo {
		return this.att;
	}




	@Input('value')
	set value(val: CastingFormatType) {

		if (this._val !== val) {
			this._val = val;
		} else {
			return;
		}



		this.valueChange.emit(val);
	}
	get value(): CastingFormatType {
		return this._val as CastingFormatType;
	}
	@Output()
	public valueChange = new EventEmitter<CastingFormatType>();
	constructor(private cdr: ChangeDetectorRef) { }

	ngOnInit(): void {
	}
}
